module.exports = __webpack_public_path__ + "static/il-employment-quality-pay-poster-48029c27aab2727cb18b518fc6fad556.pdf";